<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <!--title-->
                        <h2 class="mb-5">
                            <span v-if="mode==='add'">{{$t('text.classificationPlanEntry.addClassificationPlanEntry')}}</span><span
                                v-if="mode==='edit'">{{$t('text.classificationPlanEntry.editClassificationPlanEntry')}}</span>
                        </h2>

                        <!-- classification plan entry add/ edit form-->
                        <form class="mb-5 form-condensed">

                            <!--Parent class/selected class-->
                            <!--we have a collapse which shows us the classification plan structure with selected/parent class marked -->
                            <b-card no-body class=" mb-2">
                                <b-card-header class="p-3"
                                               :class="showCollapse ? 'collapsed' : null"
                                               :aria-expanded="showCollapse ? 'true' : 'false'"
                                               aria-controls="collapse"
                                               @click="showCollapse = !showCollapse"
                                >

                                    <div v-if="showCollapse">
                                        <span><i class="fas fa-chevron-down"></i> {{$t('text.classificationPlanEntry.hideClassificationPlan')}}</span>
                                    </div>
                                    <div v-else>
                                        <span><i class="fas fa-chevron-right"></i> {{$t('text.classificationPlanEntry.showClassificationPlan')}}</span>
                                    </div>
                                </b-card-header>
                                <b-collapse id="collapse" v-model="showCollapse">
                                    <b-card-body>

                                        <div v-if="mode === 'add'">

                                            <div v-if="classificationPlan.length > 0" class="form-group">
                                                <label for="parentClass"> {{$t('text.classificationPlanEntry.parentClass')}}</label>
                                                <input type="text" class="form-control" id="parentClass"
                                                       aria-describedby="parentClass"
                                                       v-model="selectedClassLabel" name="parentClass" disabled
                                                >
                                            </div>

                                            <div v-if="classificationPlan.length > 0"
                                                 class="mb-3 bg-light p-3 classificationPlanTreeStructureContainer">
                                                <TreeStructure
                                                        @select-item="selectItem"
                                                        :selectedClassLabel="selectedClassLabel"
                                                        :classificationPlan="classificationPlan"
                                                        :printMode="false"
                                                        :showPopover="true"
                                                        :showErrors="true"
                                                        :selectable="true"
                                                ></TreeStructure>
                                            </div>
                                            <div v-else style="display: inline-block;" class="alert alert-warning"
                                                 role="alert">
                                                {{$t('text.globals.classificationPlanNotDefined')}}
                                            </div>

                                        </div>
                                        <div v-if="mode === 'edit'">

                                            <div class="form-group">
                                                <label for="parentClass2">{{$t('text.globals.selectedClass')}}</label>
                                                <input type="text" class="form-control" id="parentClass2"
                                                       aria-describedby="parentClass"
                                                       v-model="selectedClassLabel" name="parentClass" disabled
                                                >
                                            </div>

                                            <div class="mb-3 bg-light p-3 classificationPlanTreeStructureContainer">
                                                <TreeStructure
                                                        id="treeStructure1"
                                                        :selectedClassLabel="selectedClassLabel"
                                                        :classificationPlan="classificationPlan"
                                                        :printMode="false"
                                                        :showPopover="true"
                                                        :showErrors="true"
                                                        :selectable="false"
                                                ></TreeStructure>
                                            </div>

                                        </div>


                                    </b-card-body>
                                </b-collapse>
                            </b-card>


                            <div class="form-group">
                                <label>{{mode === 'add' ? $t('text.classificationPlanEntry.parentClass') : $t('text.globals.selectedClass')}}</label>

                                    <v-select
                                            class="form-control"
                                            :options="_getClassificationPlanWithRoot"
                                            v-model="selectedClassLabel"
                                            :reduce="item => item.classificationLabel"
                                            :filter-by="knSearchFilter"
                                            label="classificationLabelName"
                                            :disabled="mode === 'edit'"
                                            @input="updateNewClassificationLabel"
                                    >
                                        <span slot="no-options">{{$t('text.globals.noOptions')}}</span>

                                        <template slot="option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'" class="pr-1">({{ option.classificationLabel }})</span> {{ option.classificationLabelName }}
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'" class="pr-1">({{ option.classificationLabel }})</span> {{ option.classificationLabelName }}
                                        </template>
                                    </v-select>

                            </div>


                            <!--Klasifikacijska oznaka-->
                            <!--Classification label input-->
                            <div class="form-group">
                                <label for="classificationLabel">{{$t('text.classificationPlanEntry.classificationLabel.title')}}</label>
                                <input type="text" class="form-control" id="classificationLabel"
                                       aria-describedby="classificationLabel"
                                       v-model="newClassificationPlanEntry.classificationLabel"
                                       name="classificationLabel"
                                       :disabled="newClassificationPlanEntry.containsRecords"
                                       :class="{'is-invalid': newClassificationPlanEntry.errors.classificationLabel.missing || newClassificationPlanEntry.errors.classificationLabel.valueError}"
                                       @input="validateField('classificationLabel'); validateClassificationLabel();"
                                >
                                <div class="invalid-feedback"
                                     v-if="newClassificationPlanEntry.errors.classificationLabel.missing">
                                    {{$t('text.classificationPlanEntry.classificationLabel.missingError')}}
                                </div>

                                <div class="invalid-feedback"
                                     v-if="newClassificationPlanEntry.errors.classificationLabel.valueError">
                                    {{$t('text.classificationPlanEntry.classificationLabel.valueError1')}}
                                    {{newClassificationPlanEntry.parentClass}}{{$t('text.classificationPlanEntry.classificationLabel.valueError2')}}
                                </div>
                            </div>


                            <!--Naziv klasifikacijske oznake-->
                            <!--Classification label name input-->
                            <div class="form-group">
                                <label for="classificationLabelName">{{$t('text.classificationPlanEntry.classificationLabelName.title')}}</label>
                                <input type="text" class="form-control" id="classificationLabelName"
                                       aria-describedby="classificationLabelName"
                                       v-model.trim="newClassificationPlanEntry.classificationLabelName"
                                       name="classificationLabelName"
                                       :class="{'is-invalid': newClassificationPlanEntry.errors.classificationLabelName || newClassificationPlanEntry.errors.classificationLabelNameIllegalCharactersError}"
                                       @input="() => {validateField('classificationLabelName'); checkForClassificationLabelNameIllegalCharactersError()}">
                                <div class="invalid-feedback"
                                     v-if="newClassificationPlanEntry.errors.classificationLabelName">
                                    {{$t('text.classificationPlanEntry.classificationLabelName.error')}}
                                </div>

                                <div class="invalid-feedback"
                                     v-if="newClassificationPlanEntry.errors.classificationLabelNameIllegalCharactersError">
                                    {{$t('text.classificationPlanEntry.classificationLabelName.illegalCharactersError')}}
                                </div>
                            </div>


                            <!--Opis klasifikacijske oznake-->
                            <!--Classification label description input-->
                            <div class="form-group">
                                <label for="classificationLabelDescription">{{$t('text.classificationPlanEntry.classificationLabelDescription.title')}}</label>
                                <textarea spellcheck="false" type="text" class="form-control"
                                          id="classificationLabelDescription"
                                          aria-describedby="classificationLabelDescription"
                                          v-model="newClassificationPlanEntry.classificationLabelDescription"
                                          name="classificationLabelDescription"
                                          :class="{'is-invalid': newClassificationPlanEntry.errors.classificationLabelDescription }"
                                          @input="validateField('classificationLabelDescription')"
                                > </textarea>
                                <div class="invalid-feedback"
                                     v-if="newClassificationPlanEntry.errors.classificationLabelDescription">
                                    {{$t('text.classificationPlanEntry.classificationLabelDescription.error')}}
                                </div>
                            </div>


                            <div class="mt-4"></div>

                            <!--Rok hrambe-->
                            <!--expiration display table-->

                            <div class="form-group clearfix">


                                <table :class="newClassificationPlanEntry.rokHrambe.length === 0 && newClassificationPlanEntry.errors.rokHrambe.expirationErrors ? 'table table-striped table-hover table-danger' : 'table table-striped table-hover'">
                                    <thead>
                                    <tr>
                                        <th scope="col">{{$t('text.classificationPlanMetadata.expiration')}}</th>
                                        <th scope="col">{{$t('text.classificationPlanEntry.expiration.year')}}</th>
                                        <th scope="col">{{$t('text.classificationPlanEntry.expiration.expirationType')}}</th>
                                        <th scope="col" class="actionsCell">{{$t('text.globals.actions')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr :class="(newClassificationPlanEntry.errors.rokHrambe.expirationFields[index].expiration || newClassificationPlanEntry.errors.rokHrambe.expirationFields[index].year.missing ||  newClassificationPlanEntry.errors.rokHrambe.expirationFields[index].year.numericError ||
                                        newClassificationPlanEntry.errors.rokHrambe.expirationFields[index].expirationType) ? 'table-danger' : '' "
                                        v-for="(rokHrambe, index) in newClassificationPlanEntry.rokHrambe" :key="rokHrambe.id">
                                        <td>{{getRokHrambeReadableLabel(rokHrambe.expiration)}}</td>
                                        <td>{{rokHrambe.year}}</td>
                                        <td>{{getVrstaGradivaReadableLabel(rokHrambe.expirationType)}}</td>
                                        <td class="actionsCell">
                                            <b-button
                                                    :disabled="newClassificationPlanEntry.containsRecords"
                                                    id="editButton1"
                                                    @click="showEditExpirationModal($event, {index: index, item: rokHrambe})"
                                                    class="btn-sm" variant="primary"><i class="fa fa-edit"></i> {{$t('text.globals.edit')}}
                                            </b-button>
                                            <b-button
                                                    :disabled="newClassificationPlanEntry.containsRecords"
                                                    :id="'deleteButton1_' + index"
                                                    @click="showDeleteExpirationModal($event, {index: index, item: rokHrambe})"
                                                    class="btn-sm" variant="danger"><i class="fa fa-trash"></i> {{$t('text.globals.delete')}}
                                            </b-button>
                                        </td>
                                    </tr>
                                    <tr v-if="newClassificationPlanEntry.rokHrambe.length === 0">
                                        <td colspan="5"><em>{{$t('text.classificationPlanEntry.expiration.noExpirationsAdded')}}</em></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <small class="text-danger"
                                       v-if="newClassificationPlanEntry.errors.rokHrambe.generalExpirationError">
                                    {{$t('text.classificationPlanEntry.expiration.generalExpirationError')}}
                                </small>

                                <b-button :disabled="newClassificationPlanEntry.containsRecords" id="addExpirationDateButton1" class="float-right mr-0 mb-3 btn-sm" variant="success"
                                          @click="showAddExpirationModal()"><i class="fa fa-plus-circle"></i> {{$t('text.classificationPlanEntry.expiration.addExpiration')}}
                                </b-button>

                                <div class="alert alert-info" v-if="newClassificationPlanEntry.containsRecords">
                                    <div class="row">
                                        <div class="col-md-1 text-center">
                                            <i class="fa fa-exclamation-triangle fa-2x d-inline-block mt-2"></i>
                                        </div>
                                        <div class="col-md-11">
                                            Za spreminjanje vrednosti o rokih hrambe na razredu, ki že vsebuje gradivo, uporabite funkcionalnost "{{$t("text.premikanjeRazredov.premestitevRazredovZgradivom")}}".<br/>
                                            <router-link
                                                    :to="{ name: 'PremikanjeRazredov' }"
                                                    class="btn btn-primary btn-sm text-white d-inline-block mt-2"
                                            ><i class="fas fa-mouse-pointer"></i> {{$t("text.premikanjeRazredov.premestitevRazredovZgradivom")}}</router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <!--Povezani sistemi-->
                            <!--Connected systems display table-->

                            <div class="form-group clearfix">

                                <table :class="newClassificationPlanEntry.errors.povezaniSistemi ? 'table table-striped table-hover table-danger' : 'table table-striped table-hover' ">
                                    <thead>
                                    <tr>
                                        <th scope="col">{{$t('text.classificationPlanMetadata.connectedSystem')}}</th>
                                        <th scope="col" class="actionsCell">{{$t('text.globals.actions')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(povezanSistem, index) in newClassificationPlanEntry.povezaniSistemi" :key="povezanSistem.id">

                                        <td>{{getConnectedSystemReadableLabel(povezanSistem)}}</td>
                                        <td class="actionsCell">
                                            <b-button
                                                    id="editButton2"
                                                    @click="showEditConnectedSystemsModal($event, {index: index, item: povezanSistem})"
                                                    class="btn-sm" variant="primary"><i class="fa fa-edit"></i> {{$t('text.globals.edit')}}
                                            </b-button>
                                            <b-button
                                                    :id="'deleteButton2_' + index"
                                                    @click="showDeleteConnectedSystemsModal($event, {index: index, item: povezanSistem})"
                                                    class="btn-sm" variant="danger"><i class="fa fa-trash"></i> {{$t('text.globals.delete')}}
                                            </b-button>
                                        </td>
                                    </tr>
                                    <tr v-if="newClassificationPlanEntry.povezaniSistemi.length === 0">
                                        <td colspan="3"><em>{{$t('text.classificationPlanEntry.connectedSystems.noConnectedSystemsAdded')}}</em></td>
                                    </tr>

                                    </tbody>
                                </table>

                                <b-button id="addConnectedSystemButton1" class="float-right mr-0 mb-3 btn-sm" variant="success"
                                          @click="showAddConnectedSystemsModal()"><i
                                        class="fa fa-plus-circle"></i> {{$t('text.classificationPlanEntry.connectedSystems.addConnectedSystem')}}
                                </b-button>

                            </div>


                            <!--Vpisnik-->
                            <!--Registry display table-->

                            <div class="form-group clearfix">

                                <table :class="newClassificationPlanEntry.errors.vpisnik ? 'table table-striped table-hover table-danger' : 'table table-striped table-hover' ">
                                    <thead>
                                    <tr>
                                        <th scope="col">{{$t('text.classificationPlanMetadata.registry')}}</th>
                                        <th scope="col" class="actionsCell">{{$t('text.globals.actions')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(vpisnik, index) in newClassificationPlanEntry.vpisnik" :key="vpisnik.id">
                                            <td>{{getRegisterItemReadableLabel(vpisnik)}} <small class="pl-2 text-muted">(povezan sistem: {{getRegisterItemConnectedSystem(vpisnik)}})</small></td>
                                            <td class="actionsCell">
                                                <b-button id="editButton3"
                                                        @click="showEditRegistryModal($event, {index: index, item: vpisnik})"
                                                        class="btn-sm" variant="primary"><i class="fa fa-edit"></i> {{$t('text.globals.edit')}}
                                                </b-button>
                                                <b-button
                                                        :id="'deleteButton3_' + index"
                                                        @click="showDeleteRegistryModal($event, {index: index, item: vpisnik})"
                                                        class="btn-sm" variant="danger"><i class="fa fa-trash"></i> {{$t('text.globals.delete')}}
                                                </b-button>
                                            </td>
                                        </tr>
                                        <tr v-if="newClassificationPlanEntry.vpisnik.length === 0">
                                            <td colspan="3"><em>{{$t('text.classificationPlanEntry.registry.noRegistriesAdded')}}</em></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <b-button id="addRegistryButton1" class="float-right mr-0 mb-3 btn-sm" variant="success"
                                          :class="{ 'disabled': newClassificationPlanEntry.povezaniSistemi.length === 0 }"
                                          @click="showAddRegistryModal()"><i class="fa fa-plus-circle"></i>
                                    {{$t('text.classificationPlanEntry.registry.addRegistry')}}
                                </b-button>

                            </div>


                            <!--creation date display-->
                            <div v-if="mode==='edit'">
                                <div class="form-group">
                                    <label for="creationDate"> {{$t('text.classificationPlanEntry.creationDate.title')}}</label>
                                     <VueCtkDateTimePicker type="text" label="" id="creationDate" format="DD-MM-YYYY"
                                                          :onlyDate="true" :noLabel="true" color="#5c5c5c"
                                                          formatted="DD.MM.YYYY"
                                                          v-model="newClassificationPlanEntry.creationDate"
                                                          name="creationDate"
                                                          disabled
                                                          :noClearButton=true
                                                          locale="sl"
                                                           :button-now-translation="$t('text.globals.now')"
                                    />
<!--
                                    <date-pick
                                        id="creationDate"
                                        v-model="newClassificationPlanEntry.creationDate"
                                        :format="'DD-MM-YYYY'"
                                        :displayFormat="'DD.MM.YYYY'"
                                        :editable="false"
                                        :nextMonthCaption="$t('text.globals.datePick.nextMonthCaption')"
                                        :prevMonthCaption="$t('text.globals.datePick.prevMonthCaption')"
                                        :setTimeCaption="$t('text.globals.datePick.setTimeCaption')"
                                        :weekdays="$t('text.globals.datePick.weekdays')"
                                        :months="$t('text.globals.datePick.months')"
                                    ></date-pick>-->



                                </div>
                            </div>


                            <!--Datum konca uporabe-->
                            <!--Usage end date input-->

                            <b-button id="collapseButton1" class="float-right mr-0 mt-3 btn-sm" variant="success"
                                      @click="toggleColapseClose()">
                                <span v-if="showCollapseClose">
                                    <i class="fa fa-minus-circle"></i> {{$t('text.classificationPlanEntry.closeClassCancel')}}
                                </span>
                                <span v-else>
                                    <i class="fa fa-plus-circle"></i>   {{$t('text.classificationPlanEntry.closeClass')}}
                                </span>
                            </b-button>

                            <div class="clearfix"></div>

                            <div class="form-group" v-if="showCollapseClose">

                                <label for="usageEndDate">{{$t('text.classificationPlanEntry.usageEndDate.title')}}</label>
                                 <VueCtkDateTimePicker type="date" label="" id="usageEndDate" format="DD-MM-YYYY"
                                                      :onlyDate="true" :noLabel="true" color="#5c5c5c"
                                                      formatted="DD.MM.YYYY"
                                                      v-model="newClassificationPlanEntry.usageEndDate"
                                                      name="usageEndDate"
                                                      @input="validateUsageEndDate"
                                                      :error="usageEndDateErrors"
                                                      locale="sl"
                                                       :button-now-translation="$t('text.globals.now')"
                                />
                                    <!-- <date-pick
                                        id="usageEndDate"
                                        name="usageEndDate"
                                        v-model="newClassificationPlanEntry.usageEndDate"
                                        :format="'DD-MM-YYYY'"
                                        :displayFormat="'DD.MM.YYYY'"
                                        @input="validateUsageEndDate()"
                                        :error="usageEndDateErrors"
                                        :nextMonthCaption="$t('text.globals.datePick.nextMonthCaption')"
                                        :prevMonthCaption="$t('text.globals.datePick.prevMonthCaption')"
                                        :setTimeCaption="$t('text.globals.datePick.setTimeCaption')"
                                        :weekdays="$t('text.globals.datePick.weekdays')"
                                        :months="$t('text.globals.datePick.months')"
                                    ></date-pick> -->

                                    <!-- <v-date-picker
                                         id="usageEndDate"
                                        name="usageEndDate"
                                        v-model="newClassificationPlanEntry.usageEndDate"
                                        @input="validateUsageEndDate()"
                                        :error="usageEndDateErrors"
                                        :popover="{ visibility: 'click' }"
                                        :input-props='{
                                            class: "form-control",
                                            placeholder: ""
                                        }'
                                        :masks="{ input: ['DD.MM.YYYY']}"
                                        /> -->

                                       <!-- <el-date-picker
                                            id="usageEndDate"
                                            name="usageEndDate"
                                            @input="validateUsageEndDate()"
                                            :error="usageEndDateErrors"
                                            :editable="true"
                                            :type="'date'"
                                            :firstDayOfWeek="1"
                                            v-on:keydown.left.stop.prevent="(e) => { e.preventDefault(); }"
                                            v-on:keydown.right.stop.prevent="(e) => { e.preventDefault(); }"
                                            v-model="newClassificationPlanEntry.usageEndDate"
                                            format="dd.MM.yyyy"
                                            value-format="dd-MM-yyyy">
                                        </el-date-picker>-->

                                <small class="text-danger"
                                       v-if="usageEndDateErrors">
                                    {{$t('text.classificationPlanEntry.usageEndDate.error')}}
                                </small>

                                <small class="text-danger"
                                       v-if="usageEndDateValueErrors">
                                    {{$t('text.classificationPlanEntry.usageEndDate.errorValue')}}
                                </small>

                            </div>


                        </form>


                        <!--add classification plan entry / save edited classification plan entry button-->
                        <div class="form-group clearfix" role="group">

                            <button id="cancelButton1" type="submit" @click="goBack" class="btn btn-secondary float-left">
                                {{$t('text.globals.cancel')}}
                            </button>

                            <div v-if="mode==='add'">
                                <button id="addClassButton1" type="submit" @click="addClassificationPlanEntry"
                                        class="btn btn-primary  float-right mr-0">
                                    {{$t('text.classificationPlanEntry.addClass')}}
                                </button>
                            </div>
                            <div v-if="mode==='edit'">
                                <button id="saveButton1" type="submit" @click="editClassificationPlanEntry"
                                        class="btn btn-primary  float-right mr-0">
                                    {{$t('text.classificationPlanEntry.saveClass')}}
                                </button>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </main>


        <!-- all the modals on this page -->
        <div>


            <!-- ERROR MODALS -->

            <b-modal
                    centered
                    size="lg"
                    id="modal-duplicates-error"
                    :title="$t('text.globals.error')"
                    :hide-header-close="true"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1">
                        {{$t('text.classificationPlanEntry.duplicatesErrorModal.content')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton1" class="float-right mr-0" @click="$bvModal.hide('modal-duplicates-error')">{{$t('text.globals.back')}}
                    </b-button>
                </div>
            </b-modal>


            <b-modal
                    centered
                    size="lg"
                    id="modal-usageEndDate-error"
                    :title="$t('text.globals.error')"
                    :hide-header-close="true"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1" v-if="usageEndDateErrors">
                        {{$t('text.classificationPlanEntry.usageEndDateErrorModal.content')}}
                    </b-col>
                    <b-col class="my-1" v-if="usageEndDateValueErrors">
                        {{$t('text.classificationPlanEntry.usageEndDate.errorValue')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton2" class="float-right mr-0" @click="$bvModal.hide('modal-usageEndDate-error')">{{$t('text.globals.back')}}
                    </b-button>
                </div>
            </b-modal>

            <b-modal
                    centered
                    size="lg"
                    id="modal-noExpirationType-error"
                    :title="$t('text.globals.error')"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1">
                        {{$t('text.classificationPlanEntry.noExpirationTypeErrorModal.content')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton3" class="float-right mr-0" @click="$bvModal.hide('modal-noExpirationType-error')">{{$t('text.globals.back')}}
                    </b-button>
                </div>
            </b-modal>


            <b-modal
                    centered
                    size="lg"
                    id="modal-generalExpiration-error"
                    :title="$t('text.globals.error')"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1">
                        {{$t('text.classificationPlanEntry.generalExpirationErrorModal.content')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton4" class="float-right mr-0" @click="$bvModal.hide('modal-generalExpiration-error')">
                        {{$t('text.globals.back')}}
                    </b-button>
                </div>
            </b-modal>


            <b-modal
                    centered
                    size="lg"
                    id="modal-tooLongLabelName-error"
                    :title="$t('text.globals.error')"
                    :hide-header-close="true"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1">
                        {{$t('text.classificationPlanEntry.tooLongLabelNameErrorModal.content')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton5" class="float-right mr-0" @click="$bvModal.hide('modal-tooLongLabelName-error')"> {{$t('text.globals.back')}}
                    </b-button>
                </div>
            </b-modal>


            <b-modal
                    centered
                    size="lg"
                    id="modal-generalExpirationExists-error"
                    :title="$t('text.globals.error')"
            >
                <b-row class="bg-light p-4">
                    <b-col class="my-1">
                        {{$t('text.classificationPlanEntry.generalExpirationExistsErrorModal.content')}}
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton6" class="float-right mr-0" @click="$bvModal.hide('modal-generalExpirationExists-error')">
                        {{$t('text.globals.cancel')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- EXPRATION MODALS -->

            <!-- add expiration modal -->
            <b-modal
                    centered
                    size="lg"
                    id="modal-add-expiration"
                    :title="$t('text.classificationPlanEntry.expirationModal.addExpiration.title')"
                    :hide-header-close="true">
                <b-row>
                    <b-col>
                        <div>
                            <div class="form-group">
                                <label for="rokHrambe">{{$t('text.classificationPlanMetadata.expiration')}}</label>
                                <v-select
                                        class="form-control"
                                        v-model="newExpiration.expiration"
                                        id="rokHrambe"
                                        name="rokHrambe"
                                        :options="rokHrambe"
                                        label="explanation"
                                        :reduce="item => item.type"
                                        :class="{'is-invalid': newExpirationErrorsEntry.expiration}"
                                        @input="validateField('expiration'); clearYear();"
                                >
                                    <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                                </v-select>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.expiration">
                                    {{$t('text.classificationPlanEntry.expirationModal.expirationError')}}
                                </small>
                            </div>


                            <div v-if="newExpiration.expiration === 'OMEJENO'" class="form-group">

                                <label for="omejenoNa">{{$t('text.classificationPlanMetadata.expirationYears')}}</label>
                                <input type="number" class="form-control" id="omejenoNa"
                                       aria-describedby="omejenoNa"
                                       v-model="newExpiration.year"
                                       name="omejenoNa"
                                       :class="{'is-invalid': newExpirationErrorsEntry.year.missing ||  newExpirationErrorsEntry.year.numericError}"
                                       @input="validateField('year')"
                                >
                                <label class="let">let</label>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.year.missing">
                                    {{$t('text.classificationPlanEntry.expirationModal.restrictedToMissingError')}}
                                </small>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.year.numericError">
                                    {{$t('text.classificationPlanEntry.expirationModal.restrictedToNumericError')}}
                                </small>
                            </div>
                            <br>

                            <div class="form-check">
                                <input id="isGeneral" class="form-check-input" type="checkbox"
                                       v-model="newExpiration.isGeneral" @input="clearExpirationType()">
                                <label class="mb-4" for="isGeneral">{{$t('text.classificationPlanEntry.expirationModal.generalExpiration')}}</label>
                            </div>

                            <div v-if="newExpiration.isGeneral != true" class="form-group">

                                <label for="expirationType">{{$t('text.classificationPlanEntry.expirationModal.expirationType')}}</label>
                                <v-select
                                        class="form-control"
                                        v-model="newExpiration.expirationType"
                                        id="expirationType"
                                        name="expirationType"
                                        label="description"
                                        :reduce="item => item.id.toString()"
                                        :options="vrstaGradiva"
                                        :class="{'is-invalid': newExpirationErrorsEntry.expirationType}"
                                        @input="validateField('expirationType'); checkForDuplicatesInArrayField('rokHrambe', 'add')"
                                >
                                    <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                                </v-select>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.expirationType">
                                    {{$t('text.classificationPlanEntry.expirationModal.expirationTypeError')}}
                                </small>
                            </div>

                            <small class="text-danger" v-if="duplicateExpirationError">
                                {{$t('text.classificationPlanEntry.expirationModal.duplicateExpirationError1')}}{{getVrstaGradivaReadableLabel(newExpiration.expirationType)}}{{$t('text.classificationPlanEntry.expirationModal.duplicateExpirationError2')}}
                            </small>
                        </div>
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="cancelButton2" class="float-left"
                              @click="$bvModal.hide('modal-add-expiration')">
                        {{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="addExpirationDateButton2" class="float-right mr-0" variant="primary" @click="addExpiration();">{{$t('text.classificationPlanEntry.expirationModal.addExpiration.addExpiration')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- edit expiration modal -->
            <b-modal
                    centered
                    size="lg"
                    id="modal-edit-expiration"
                    :title="$t('text.classificationPlanEntry.expirationModal.editExpiration.title')"
                    :hide-header-close="true">
                <b-row>
                    <b-col>
                        <div>
                            <div class="form-group">
                                <label for="rokHrambe2">{{$t('text.classificationPlanMetadata.expiration')}}</label>
                                <v-select
                                        class="form-control"
                                        v-model="newExpiration.expiration"
                                        id="rokHrambe2"
                                        name="rokHrambe2"
                                        :options="rokHrambe"
                                        label="explanation"
                                        :reduce="item => item.type"
                                        :class="{'is-invalid':  newExpirationErrorsEntry.expiration}"
                                        @input="validateField('expiration'); clearYear();"
                                >
                                    <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                                </v-select>
                                <small class="text-danger" v-if=" newExpirationErrorsEntry.expiration">
                                    {{$t('text.classificationPlanEntry.expirationModal.expirationError')}}
                                </small>
                            </div>

                            <!--Omejeno na (ce pri roku hrambe izberemo opcijo 'omejeno')-->
                            <div v-if="newExpiration.expiration === 'OMEJENO'" class="form-group">

                                <label for="omejenoNa2">{{$t('text.classificationPlanMetadata.expirationYears')}}</label>
                                <input type="text" style="display: inline-block" class="form-control"
                                       id="omejenoNa2"
                                       aria-describedby="omejenoNa2"
                                       v-model="newExpiration.year"
                                       name="omejenoNa2"
                                       :class="{'is-invalid': newExpirationErrorsEntry.year.missing || newExpirationErrorsEntry.year.numericError}"
                                       @input="validateField('year')"
                                >
                                <label style="display: inline-block">{{$t('text.classificationPlanEntry.expirationModal.years')}}</label>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.year.missing">
                                    {{$t('text.classificationPlanEntry.expirationModal.restrictedToMissingError')}}
                                </small>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.year.numericError">
                                    {{$t('text.classificationPlanEntry.expirationModal.restrictedToNumericError')}}
                                </small>
                            </div>
                            <br>

                            <div class="form-check">
                                <input id="isGeneral2" class="form-check-input" type="checkbox"
                                       v-model="newExpiration.isGeneral" @input="clearExpirationType()">
                                <label class="mb-4" for="isGeneral2">{{$t('text.classificationPlanEntry.expirationModal.generalExpiration')}}</label>
                            </div>


                            <div v-if="newExpiration.isGeneral != true" class="form-group">
                                <label for="expirationType2">{{$t('text.classificationPlanEntry.expirationModal.expirationType')}}</label>
                                <v-select
                                        class="form-control"
                                        v-model="newExpiration.expirationType"
                                        id="expirationType2"
                                        name="expirationType2"
                                        label="description"
                                        :reduce="item => item.id.toString()"
                                        :options="vrstaGradiva"
                                        :class="{'is-invalid': newExpirationErrorsEntry.expirationType}"
                                        @input="validateField('expirationType', selectedRow.index); checkForDuplicatesInArrayField('rokHrambe', 'edit')"
                                >
                                    <span slot="no-options">{{$t('text.globals.noOptions')}}</span>

                                </v-select>
                                <small class="text-danger" v-if="newExpirationErrorsEntry.expirationType">
                                    {{$t('text.classificationPlanEntry.expirationModal.expirationTypeError')}}
                                </small>
                            </div>

                            <small class="text-danger" v-if="duplicateExpirationError">
                                {{$t('text.classificationPlanEntry.expirationModal.duplicateExpirationError1')}}{{newExpiration.expirationType}}{{$t('text.classificationPlanEntry.expirationModal.duplicateExpirationError2')}}
                            </small>
                        </div>
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button  id="cancelButton3" class="float-left" @click="$bvModal.hide('modal-edit-expiration')">{{$t('text.globals.cancel')}}</b-button>
                    <b-button  id="saveExpirationDateButton3" class="float-right mr-0" variant="primary" @click="editExpiration();">{{$t('text.classificationPlanEntry.expirationModal.editExpiration.saveExpiration')}}
                    </b-button>
                </div>
            </b-modal>


            <!--delete expiration modal -->
            <b-modal
                    centered
                    size="lg"
                    id="modal-delete-expiration"
                    :title="$t('text.classificationPlanEntry.expirationModal.deleteExpiration.title')"
                    :hide-header-close="true"
            >
                <b-row>
                    <b-col>
                        <p v-if="selectedRow.item">{{$t('text.classificationPlanEntry.expirationModal.deleteExpiration.content')}}
                            {{getRokHrambeReadableLabel(selectedRow.item.expiration)}} ? </p>
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="cancelButton4" class="float-left" @click="$bvModal.hide('modal-delete-expiration')">{{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="deleteButton4" class="float-right mr-0" variant="danger"
                              @click="deleteExpiration()">{{$t('text.globals.delete')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- CONNECTED SYSTEMS MODALS -->

            <!--add  connected system modal -->
            <b-modal
                    centered
                    size="lg"
                    id="modal-add-connectedSystem"
                    :title="$t('text.classificationPlanEntry.connectedSystemsModal.addConnectedSystem.title')"
                    :hide-header-close="true"
            >
                <b-row>
                    <b-col>

                        <div class="form-group">
                            <label for="povezaniSistemi">{{$t('text.classificationPlanMetadata.connectedSystems')}}</label>
                            <v-select
                                    class="form-control"
                                    id="povezaniSistemi"
                                    name="povezaniSistemi"
                                    label="description"
                                    :options="povezaniSistemi"
                                    :reduce="item => item.id"
                                    v-model="newConnectedSystem"
                                    @input="validateArrayField('povezaniSistemi'); checkForDuplicatesInArrayField('povezaniSistemi', 'add')"
                                    :class="{'is-invalid': newConnectedSystemErrors}"
                            >
                                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                            </v-select>
                            <small class="text-danger" v-if="newConnectedSystemErrors">
                                {{$t('text.classificationPlanEntry.connectedSystemsModal.connectedSystemsError')}}
                            </small>
                        </div>


                        <small class="text-danger" v-if="duplicateConnectedSystemsError">
                            {{$t('text.classificationPlanEntry.connectedSystemsModal.duplicateConnectedSystemsError1')}}{{getConnectedSystemReadableLabel(newConnectedSystem)}}{{$t('text.classificationPlanEntry.connectedSystemsModal.duplicateConnectedSystemsError2')}}
                        </small>

                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="cancelButton5" class="float-left"
                              @click="$bvModal.hide('modal-add-connectedSystem')">{{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="saveConnectedSystemButton1" class="float-right mr-0" variant="primary" @click="addConnectedSystems()">{{$t('text.classificationPlanEntry.connectedSystemsModal.addConnectedSystem.addConnectedSystem')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- edit connected system modal -->

            <b-modal
                    centered
                    size="lg"
                    id="modal-edit-connectedSystem"
                    :title="$t('text.classificationPlanEntry.connectedSystemsModal.editConnectedSystem.title')"
                    :hide-header-close="true">

                <b-row>
                    <b-col>
                        <div class="form-group">
                            <label for="povezaniSistemi2">{{$t('text.classificationPlanMetadata.connectedSystems')}}</label>
                            <v-select
                                    class="form-control"
                                    id="povezaniSistemi2"
                                    name="povezaniSistemi2"
                                    label="description"
                                    :options="povezaniSistemi"
                                    :reduce="item => item.id"
                                    v-model="newConnectedSystem"
                                    @input="validateArrayField('povezaniSistemi'); checkForDuplicatesInArrayField('povezaniSistemi', 'edit')"
                                    :class="{'is-invalid': newConnectedSystemErrors}"
                            >
                                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                            </v-select>
                            <small class="text-danger" v-if="newConnectedSystemErrors">
                                {{$t('text.classificationPlanEntry.connectedSystemsModal.connectedSystemsError')}}
                            </small>
                        </div>

                        <small class="text-danger" v-if="duplicateConnectedSystemsError">
                            {{$t('text.classificationPlanEntry.connectedSystemsModal.duplicateConnectedSystemsError1')}}{{getConnectedSystemReadableLabel(newConnectedSystem)}}{{$t('text.classificationPlanEntry.connectedSystemsModal.duplicateConnectedSystemsError2')}}
                        </small>

                    </b-col>
                </b-row>

                <div slot="modal-footer" class="w-100">
                    <b-button id="cancelButton6" class="float-left"
                              @click="$bvModal.hide('modal-edit-connectedSystem')">{{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="saveConnectedSystemButton2" class="float-right mr-0" variant="primary" @click="editConnectedSystems()">{{$t('text.classificationPlanEntry.connectedSystemsModal.editConnectedSystem.saveConnectedSystem')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- REGISTRY MODALS -->

            <!-- add registry modal -->

            <b-modal
                    centered
                    size="lg"
                    id="modal-add-registry"
                    :title="$t('text.classificationPlanEntry.registryModal.addRegistry.title')"
                    :hide-header-close="true">

                <b-row>
                    <b-col>

                        <div class="form-group">
                            <label for="vpisnik">{{$t('text.classificationPlanMetadata.registry')}}</label>

                            <a class="btn btn-sm btn-link float-right text-info mt-2" @click="selectAllVpisnik"
                               v-if="newClassificationPlanEntry.vpisnik.length < vpisniki.length">{{$t('text.classificationPlanEntry.registryModal.selectAll')}}</a>
                            <div class="clearfix"></div>
                            <v-select
                                    class="form-control"
                                    v-model="newRegistry"
                                    id="vpisnik"
                                    name="vpisnik"
                                    multiple
                                    label="description"
                                    :options="filteredVpisniki"
                                    :reduce="item => item.id"
                                    @input="() => {validateArrayField('vpisnik'); checkForDuplicatesInArrayField('vpisnik', 'add')}"
                                    :class="{'is-invalid': newRegistryErrors}"
                            >
                                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>

                                <template v-slot:option="option">
                                    {{option.description }} <small class="pl-2 text-muted">({{$t('text.classificationPlanMetadata.connectedSystem')}}: {{option.connectedSystem}})</small>
                                </template>
                                <template v-slot:selected-option="option">
                                    {{option.description }} <small class="pl-2 text-muted">({{$t('text.classificationPlanMetadata.connectedSystem')}}: {{option.connectedSystem}})</small>
                                </template>

                            </v-select>
                            <small class="text-danger" v-if="newRegistryErrors">
                                {{$t('text.classificationPlanEntry.registryModal.registryError')}}
                            </small>
                        </div>

                        <small class="text-danger" v-if="duplicateRegistryError">
                            {{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError1')}}<span v-if="newRegistryDuplicatesList.length<=1">{{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError2_1')}}</span><span v-else >{{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError2_2')}}</span><span
                                v-for="item, index in newRegistryDuplicatesList">{{getRegisterItemReadableLabel(item)}}, </span>
                            {{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError3')}}<span v-if="newRegistryDuplicatesList.length<=1">{{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError4_1')}}</span><span v-else >{{$t('text.classificationPlanEntry.registryModal.duplicateRegistryError4_2')}}</span>
                        </small>

                    </b-col>
                </b-row>

                <div slot="modal-footer" class="w-100">
                    <b-button id="previousButton7" class="float-left" @click="$bvModal.hide('modal-add-registry')">
                        {{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="saveRegistryButton1" class="float-right mr-0" variant="primary" @click="addRegistry()">{{$t('text.classificationPlanEntry.registryModal.addRegistry.addRegistry')}}
                    </b-button>
                </div>
            </b-modal>


            <!-- edit registry modal -->

            <b-modal
                    centered
                    size="lg"
                    id="modal-edit-registry"
                    :title="$t('text.classificationPlanEntry.registryModal.editRegistry.title')"
                    :hide-header-close="true">
                <b-row>
                    <b-col>

                        <div class="form-group">
                            <label for="vpisnik2">{{$t('text.classificationPlanMetadata.registry')}}</label>
                            <v-select
                                    class="form-control"
                                    v-model="newRegistry"
                                    id="vpisnik2"
                                    name="vpisnik2"
                                    :options="filteredVpisniki"
                                    label="description"
                                    :reduce="item => item.id"
                                    @input="() => {validateArrayField('vpisnik'); checkForDuplicatesInArrayField('vpisnik', 'edit')}"
                                    :class="{'is-invalid': newRegistryErrors}"
                            >
                                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                                <template v-slot:option="option">
                                    {{option.description }} <small class="pl-2 text-muted">({{$t('text.classificationPlanMetadata.connectedSystem')}}: {{option.connectedSystem}})</small>
                                </template>
                                <template v-slot:selected-option="option">
                                    {{option.description }} <small class="pl-2 text-muted">({{$t('text.classificationPlanMetadata.connectedSystem')}}: {{option.connectedSystem}})</small>
                                </template>

                            </v-select>
                            <small class="text-danger" v-if="newRegistryErrors">
                                {{$t('text.classificationPlanEntry.registryModal.registryError')}}
                            </small>
                        </div>

                        <small class="text-danger" v-if="duplicateRegistryError && isString(newRegistry)">
                            {{$t('text.classificationPlanEntry.registryModal.duplicateRegistryErrorEdit1')}}{{getRegisterItemReadableLabel(newRegistry)}}{{$t('text.classificationPlanEntry.registryModal.duplicateRegistryErrorEdit2')}}
                        </small>

                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-button id="cancelButton7" class="float-left"
                              @click="$bvModal.hide('modal-edit-registry')">{{$t('text.globals.cancel')}}
                    </b-button>
                    <b-button id="saveRegistryButton2" class="float-right mr-0" variant="primary" @click="editRegistry()">{{$t('text.classificationPlanEntry.registryModal.editRegistry.saveRegistry')}}
                    </b-button>
                </div>
            </b-modal>


        </div>

    </div>

</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import TreeStructure from '../components/TreeStructure';
    import axios from "axios";
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import flatten from "flat";

    library.add(faHome);

    export default {
        name: 'ClassificationPlanEntry',
        components: {
            SidebarNavigation,
            TreeStructure,
            vSelect
        },
        data() {
            return {
                // vpisniki: ['Civilno','Nepravdno','Izvršilno','Ostalo', 'Gospodarsko', 'Brezplačna pravna pomoč',
                //     'Kazensko', 'Zemljiškoknjižno', 'Insolvenčno', 'Upravno', 'Mediacije', 'Socialno',
                //     'Delovno-socialno', 'Prekrškovno', 'Pravdno', 'Delovno', 'Gospodarsko (Srg)', 'Zapuščinsko'],
                vpisniki: [],
                filteredVpisniki: [],
                povezaniSistemi: [],
                rokHrambe: [],
                vrstaGradiva: [],
                classificationPlan: this.$store.getters.getClassificationPlan,
                mode: null,
                selectedClassLabel: null,
                showCollapse: false,
                showCollapseClose: true,
                parent: null,
                siblingArray: null,
                newClassificationPlanEntry: {
                    classificationLabel: null,
                    classificationLabelName: null,
                    classificationLabelDescription: null,
                    rokHrambe: [],
                    povezaniSistemi: [],
                    vpisnik: [],
                    creationDate: null,
                    usageEndDate: null,
                    parentClass: this.$route.params.parentName,
                    item: [],
                    errors: {
                        classificationLabelNameIllegalCharactersError: false,
                        classificationLabelNameDuplicateError: false,
                        classificationLabel: {
                            missing: false,
                            valueError: false
                        },
                        classificationLabelName: false,
                        classificationLabelDescription: false,
                        rokHrambe: {
                            expirationErrors: false,
                            generalExpirationError: false,
                            expirationFields: [],
                        },
                        povezaniSistemi: false,
                        vpisnik: false,
                    },
                    structure: {
                        changed: true,
                        isOpen: null,
                        depth: null,
                        checked: true,
                    },

                },

                newExpiration: {
                    expiration: null,
                    year: null,
                    expirationType: null,
                    isGeneral: false
                },
                newConnectedSystem: null,
                newRegistry: [],

                newConnectedSystemErrors: false,
                newRegistryErrors: false,

                newExpirationErrorsEntry: {
                    expiration: false,
                    year: {
                        missing: false,
                        numericError: false,
                    },
                    expirationType: false
                },

                selectedRow: {
                    index: null,
                    item: null,
                },

                closeClassEnabled: false,

                usageEndDateErrors: false,
                usageEndDateValueErrors: false,

                previouslySelectedExpiration: null,

                duplicateConnectedSystemsError: false,
                duplicateRegistryError: false,
                duplicateExpirationError: false,
                newRegistryDuplicatesList: [],
                knSearchFilter: (option, label, search) => {
                  let temp = search.toLowerCase();
                  return option.classificationLabel.toLowerCase().indexOf(temp) > -1 ||
                      option.classificationLabelName.toLowerCase().indexOf(temp) > -1
                }

            }

        },
        computed: {

            _getClassificationPlanWithRoot() {
                let classificationPlan = _.cloneDeep(
                    this.$store.getters.getClassificationPlan
                );

                classificationPlan.unshift({
                    alfrescoId: null,
                    classificationLabel: "none",
                    containsRecords: false,
                    classificationLabelName: this.$t('text.classificationPlanEntry.rootPlan'),
                    classificationLabelDescription: this.$t('text.classificationPlanEntry.rootPlan'),
                    duplicatedClassLabels: [],
                    rokHrambe: [],
                    vpisnik: [],
                    povezaniSistemi: [],
                    usageEndDate: null,
                    creationDate: null,
                    parentClass: null,
                    item: [],
                    errors: {},
                    structure: {
                        isOpen: true,
                        checked: true,
                        depth: 1,
                        changed: false,
                        match: false
                    }
                });


                let flattenClassificationPlan = flatten(classificationPlan);
                let classificationPlanToReturn = [];

                // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
                _.map(flattenClassificationPlan, function(val,key, idx){
                    if(key.indexOf('classificationLabelName') > -1) {
                        let index = 0;
                        let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

                        if((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
                            let item = {
                                classificationLabelName: val,
                                classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
                            }
                            classificationPlanToReturn.push(item);
                        }
                    }
                });

                console.log("classificationPlanToReturn", classificationPlanToReturn);
                return classificationPlanToReturn;
            }

        },
        mounted() {



            this.initClassificationPlanEntry();

            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                console.log("hide modal ", modalId);
                if (modalId === "modal-add-expiration") {
                    this.closeAddExpirationModal();
                }
                if (modalId === "modal-edit-expiration") {
                    this.closeEditExpirationModal();
                }

                if (modalId === "modal-delete-expiration") {
                    this.closeDeleteExpirationModal();
                }

                if (modalId === "modal-add-connectedSystem") {
                    this.closeAddConnectedSystemsModal();
                }

                if (modalId === "modal-edit-connectedSystem") {
                    this.closeEditConnectedSystemsModal();
                }

                if (modalId === "modal-add-registry") {
                    this.closeAddRegistryModal();
                }

                if (modalId === "modal-edit-registry") {
                    this.closeEditRegistryModal();
                }

                if (modalId === "modal-delete-registry") {
                    this.closeDeleteRegistryModal();
                }

            });

        },

        methods: {

            async initClassificationPlanEntry() {


                const _this = this;

                this.vpisniki = this.$store.getters.getRegisterOptions;
                //this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions;
                this.rokHrambe = this.$store.getters.getStorageDateOptions;
                this.vrstaGradiva = _.filter(this.$store.getters.getDocumentTypeOptions, { active: true });

                let ehrambaPovezaniSistemi = [];
                _.each(this.$store.getters.getConnectedSystemsOptions, function (innerItem) {
                    if(innerItem.ehramba && innerItem.rm) {
                        ehrambaPovezaniSistemi.push(innerItem);
                    }
                });
                this.povezaniSistemi = ehrambaPovezaniSistemi;



                console.log("roki hrambe: ", this.rokHrambe);

                // TODO: rewrite this in next version!!!


                setTimeout(function () {
                    _this.getVpisnikiOptions();
                },100)

                // preverimo, če dobimo kot atribut v urlju parentName (gre za dodajanje posameznega razreda v klasifikacijski načrt) ali pa className (gre za urejanje že obstoječega vnosa v klasifikacijskem načrtu)

                // we check if  we are adding a classification plan entry or editing an existing one via the $route.params.ClassificationPlanEntryType variable

                if (this.$route.params.ClassificationPlanEntryType === "addClassificationPlanEntry") {

                    this.mode = "add";

                    this.selectedClassLabel = this.$route.params.className;
                    this.newClassificationPlanEntry.parentClass = this.$route.params.className;
                    this.classificationPlan = await this.$store.getters.getClassificationPlan;

                    // if we are adding a new class, the new class needs to inherit all of the expirations, connected systems and registries from its parent class --> also there is a rule for the new class name
                    this.findParent();

                    // in add mode, there is no usage end date yet set, so we close the collapse
                    this.showCollapseClose = false;


                } else if (this.$route.params.ClassificationPlanEntryType === "editClassificationPlanEntry") {

                    this.mode = "edit";

                    this.selectedClassLabel = this.$route.params.className;

                    // if we are in the edit mode, we need to find the class that we are editing in the structure
                    this.newClassificationPlanEntry = _.cloneDeep(this.returnClass(this.selectedClassLabel));

                    // in edit mode, we only open the collapse if the usage end date is already set
                    this.showCollapseClose = !(this.newClassificationPlanEntry.usageEndDate == null); //TRUE === OPEN

                }

                console.log("parent class: ", this.newClassificationPlanEntry.parentClass);

                this.siblingArray = this.returnSiblingArray(this.newClassificationPlanEntry.parentClass);


            },

            getVpisnikiOptions() {

                let _this = this;

                let filteredVpisniki = [];

                _.forEach(_this.vpisniki, function (value, key) {

                    if (_.includes(_this.newClassificationPlanEntry.povezaniSistemi, value.connectedSystem)) {
                        filteredVpisniki.push(value);
                    }


                });

                this.filteredVpisniki = filteredVpisniki;
            },

            // ko v enem izmed tree itemov izberemo razred, nastavimo data spremenljivko izbrani razred (selectedClassLabel) izbrani razred lahko urejamo, brišemo, zapremo, ali pa mu dodajamo podrejene razrede
            // when we select a class in one of the treeItems, we set a selectedClasslabel variable to the selected class' label
            selectItem(item) {
                console.log("izbran razred: ", item.classificationLabel);
                if (this.selectedClassLabel === item.classificationLabel) {
                    this.selectedClassLabel = "none";
                    this.newClassificationPlanEntry.parentClass = "none";
                    this.siblingArray = this.returnSiblingArray("none");
                    this.checkForClassificationLabelNameDuplicateError();

                } else {
                    this.selectedClassLabel = item.classificationLabel;
                    this.newClassificationPlanEntry.parentClass = item.classificationLabel;
                    this.siblingArray = this.returnSiblingArray(item.classificationLabel);
                    this.checkForClassificationLabelNameDuplicateError();
                }

                this.validateClassificationLabel();
            },

            getRegisterItemReadableLabel(registerId) {
                const _this = this;


                if(typeof registerId === 'object') {
                    return _.filter(_this.vpisniki, {'id': registerId.id.toString()})[0].description;
                } else {
                    return _.filter(_this.vpisniki, {'id': registerId.toString()})[0].description;
                }
            },

            getRegisterItemConnectedSystem(registerId) {
                const _this = this;


                if(typeof registerId === 'object') {
                    return _.filter(_this.vpisniki, {'id': registerId.id.toString()})[0].connectedSystem;
                } else {
                    return _.filter(_this.vpisniki, {'id': registerId.toString()})[0].connectedSystem;
                }
            },

            getConnectedSystemReadableLabel(connectedSystemId) {
                const _this = this;

                if(_.filter(_this.povezaniSistemi, {'id': connectedSystemId.toString()})[0]) {
                  return _.filter(_this.povezaniSistemi, {'id': connectedSystemId.toString()})[0].description;
                } else {
                  return connectedSystemId
                }

            },

            getVrstaGradivaReadableLabel(vrstaGradivaId) {



                if( vrstaGradivaId == null){

                    return null;
                }
                else{
                    const _this = this;


                    for(let i = 0; i< this.vrstaGradiva.length; i++){

                        if(this.vrstaGradiva[i].id.toString() === vrstaGradivaId.toString()){


                            return this.vrstaGradiva[i].description;
                        }


                    }

                    return null;
                }

            },

            getRokHrambeReadableLabel(rokHrambeType) {

                if( rokHrambeType == null){
                    return null;
                }
                else{

                    for(let i = 0; i< this.rokHrambe.length; i++){
                        if(this.rokHrambe[i].type.toString() === rokHrambeType.toString()){
                            return this.rokHrambe[i].explanation;
                        }

                    }

                    return null;
                }

            },

            // we go back to the main classification plan page
            goBack() {
                //this.$router.push("/classificationPlan");
                this.$router.push({name: 'ClassificationPlan', params: {expandAll: true, ccUpdated: true}});
            },

            isString(value){
                return _.isString(value);
            },

            // toggles the opening and closing of the usage end date input
            toggleColapseClose() {

                if (this.showCollapseClose) {
                    this.newClassificationPlanEntry.usageEndDate = null;
                    this.usageEndDateErrors = false;
                    this.usageEndDateValueErrors = false;
                }

                this.showCollapseClose = !this.showCollapseClose;

            },

            // ADD MODE FUNCTIONS

            // se kliče, ko oddamo obrazec za dodajanje posameznega razreda v klasifikacijski načrt
            // gets called, when we want to save the newly added classification plan class
            addClassificationPlanEntry() {
                const _this = this;

                // if the user  changed the parent class in the form, we update that
                this.newClassificationPlanEntry.parentClass = this.selectedClassLabel;


                // first we need to validate the whole class
                if (this.validateClass()) {

                    // we add a structure object which helps us with managing the structure of the classification plan

                    this.newClassificationPlanEntry.structure.checked = true;
                    this.newClassificationPlanEntry.structure.match = false;


                    // creation date attribute is added
                    let today = new Date();
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    let yyyy = today.getFullYear();

                    today = dd + '-' + mm + '-' + yyyy;
                    this.newClassificationPlanEntry.creationDate = today;


                    if (this.validateUsageEndDate()) {

                        //we check if the  classificationLabel name is too long (it shouldn't be more than 50 characters)
                        if (!this.checkForTooLongLabelName(this.newClassificationPlanEntry.classificationLabelName)) {

                            // we check if the classification label that we added doesn't already exist in the structure
                            if (!this.checkForDuplicateClasses(this.newClassificationPlanEntry.classificationLabel)) {

                                // if the parent class is set to 'none' , we push it to the root of the plan, else we call a function to append it to the selected parent class
                                if (this.newClassificationPlanEntry.parentClass === "none") {
                                    this.classificationPlan.push(this.newClassificationPlanEntry);
                                } else {
                                    for (let i = 0; i < this.classificationPlan.length; i++) {
                                      console.log("newClassificationPlanEntry --------> ", this.newClassificationPlanEntry)

                                       // remove alfrescoId from rokHrambe
                                      _.each(this.newClassificationPlanEntry.rokHrambe, function(val,idx) {
                                        _this.newClassificationPlanEntry.rokHrambe[idx].alfrescoId = null;
                                      });

                                      console.log("newClassificationPlanEntry --------> ", this.newClassificationPlanEntry)
                                      this.classificationPlan[i] = this.addClassificationPlanEntryRec(this.classificationPlan[i], this.newClassificationPlanEntry);

                                    }
                                }

                                this.checkSiblingClassesForClassificationLabelNameDuplicateError();

                                console.log("-------> ", this.classificationPlan);

                                // if everything is ok, we save the new structure to the store
                                this.$store.dispatch("setClassificationPlan", this.classificationPlan);
                                this.$store.dispatch("setClassificationPlanFiltered", this.classificationPlan);
                                this.$router.push({name: 'ClassificationPlan', params: {expandAll: true, ccUpdated: true}});

                            } else {

                                // we show a modal for duplicates error
                                this.$bvModal.show('modal-duplicates-error');
                            }
                        } else {

                            // we show a modal for too long label name error
                            this.$bvModal.show('modal-tooLongLabelName-error');
                        }

                    } else {
                        this.$bvModal.show('modal-usageEndDate-error');
                    }

                }
                else {
                    console.log("validacija neuspešna: manjkajoči metapodatki");

                    Vue.$toast.open({
                        message: this.$t('text.classificationPlanEntry.metadataValidationErrorToast'),
                        type: 'error',
                        position: 'top-right'
                    });

                    let errorField = this.$el.querySelector(".is-invalid");
                    let elmTop = errorField ? errorField.getBoundingClientRect().top + window.scrollY - 100 : 0;

                    window.scrollTo(0, elmTop);
                }

            },

            // this function looks for a class with a parent class label that we selected and appends the new class to it
            addClassificationPlanEntryRec(classificationPlan, classificationPlanEntry) {

                if (classificationPlan.classificationLabel === classificationPlanEntry.parentClass) {

                    let depth = classificationPlan.structure.depth + 1;
                    let isOpen = (depth === 1 || depth === 2);


                    classificationPlanEntry.structure.isOpen = isOpen;
                    classificationPlanEntry.structure.depth = depth;

                    classificationPlan.item.push(classificationPlanEntry);


                    return classificationPlan;

                }

                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.addClassificationPlanEntryRec(classificationPlan.item[i], classificationPlanEntry)
                }

                return classificationPlan;
            },


            // this function checks if the classification label name is too long (more than 150 chars)
            checkForTooLongLabelName(classificationLabelName) {
                if (classificationLabelName.length > 150) {

                    return true;
                } else {

                    return false;
                }
            },

            // checks if the classification label of the class that we are adding/editing already exists in the structure
            checkForDuplicateClasses(classificationLabel) {

                console.log("new label:", classificationLabel);
                for (let i = 0; i < this.classificationPlan.length; i++) {
                    if (this.checkForDuplicateClassesRec(this.classificationPlan[i], classificationLabel)) {
                        return true;
                    }
                }
                return false;
            },

            checkForDuplicateClassesRec(classificationPlan, classificationLabel) {

                if (classificationPlan.classificationLabel === classificationLabel) {

                    if (!(this.mode === "edit" && this.selectedClassLabel === classificationPlan.classificationLabel)) {
                        return true;
                    }

                } else {
                    for (let i = 0; i < classificationPlan.item.length; i++) {
                        if (this.checkForDuplicateClassesRec(classificationPlan.item[i], classificationLabel)) {
                            return true;
                        }
                    }

                    return false;
                }

            },

            //this function gets called if we are in add mode, it makes sure all of the expirations, connected systems and registries are inherited from the parent class
            findParent() {
                for (let i = 0; i < this.classificationPlan.length; i++) {
                    this.findParentRec(this.classificationPlan[i]);
                }
                return;
            },
            findParentRec(classificationPlan) {
                if (classificationPlan.classificationLabel === this.newClassificationPlanEntry.parentClass) {
                    let plan = _.cloneDeep(classificationPlan);


                    this.newClassificationPlanEntry.rokHrambe = plan.rokHrambe;
                    this.newClassificationPlanEntry.vpisnik = plan.vpisnik;
                    this.newClassificationPlanEntry.povezaniSistemi = plan.povezaniSistemi;
                    this.newClassificationPlanEntry.errors.rokHrambe = plan.errors.rokHrambe;
                    this.newClassificationPlanEntry.errors.vpisnik = plan.errors.vpisnik;
                    this.newClassificationPlanEntry.errors.povezaniSistemi = plan.errors.povezaniSistemi;


                    this.newClassificationPlanEntry.classificationLabel = plan.classificationLabel.slice(0, plan.classificationLabel.length);
                    this.validateField("classificationLabel");

                } else {
                    for (let i = 0; i < classificationPlan.item.length; i++) {
                        this.findParentRec(classificationPlan.item[i]);
                    }
                }
            },


            //EDIT MODE FUNCTIONS


            // ko oddajamo obrazec za urejanje klasifikacijskega načrta, poiščemo izbran razred v strukturi in ga zamenjamo z objektom newClassificationPlanEntry
            // gets called, when we want to save the edited classification plan class
            editClassificationPlanEntry() {


                // if we changed the classification label, we need to update the parent label in all the class children
                if (this.selectedClassLabel !== this.newClassificationPlanEntry.classificationLabel) {
                    for (let i = 0; i < this.newClassificationPlanEntry.item.length; i++) {
                        this.newClassificationPlanEntry.item[i].parentClass = this.newClassificationPlanEntry.classificationLabel;

                        this.updateClassificationLabelErrors(this.newClassificationPlanEntry.item[i]);

                    }
                }


                // first we need to validate the whole class and check if all of the fields are valid
                if (this.validateClass()) {

                    if (this.validateUsageEndDate()) {

                        //we check if the  classificationLabel name is too long (it shouldn't be more than 50 characters)
                        if (!this.checkForTooLongLabelName(this.newClassificationPlanEntry.classificationLabelName)) {

                            // we check if the classification label that we edited doesn't already exist in the structure
                            if (!this.checkForDuplicateClasses(this.newClassificationPlanEntry.classificationLabel)) {


                                // if there are no errors, we can switch the new class that we edited with te old one
                                for (let i = 0; i < this.classificationPlan.length; i++) {
                                    this.classificationPlan[i] = this.editClassificationPlanEntryRec(this.classificationPlan[i], this.newClassificationPlanEntry);
                                }

                                this.checkSiblingClassesForClassificationLabelNameDuplicateError();

                                // we dispatch the new structure
                                this.$store.dispatch("setClassificationPlan", this.classificationPlan);
                                this.$store.dispatch("setClassificationPlanFiltered", this.classificationPlan);
                                this.$router.push({name: 'ClassificationPlan', params: {expandAll: true, ccUpdated: true}});

                            } else {

                                // we show a modal for duplicates error
                                this.$bvModal.show('modal-duplicates-error');
                            }
                        } else {
                            // we show a modal for too long label name error
                            this.$bvModal.show('modal-tooLongLabelName-error');
                        }

                    } else {

                        this.$bvModal.show('modal-usageEndDate-error');
                    }

                } else {
                    console.log("validacija neuspešna: manjkajoči metapodatki 111");

                    Vue.$toast.open({
                        message: this.$t('text.classificationPlanEntry.metadataValidationErrorToast'),
                        type: 'error',
                        position: 'top-right'
                    });

                    let errorField = this.$el.querySelector(".is-invalid");
                    let elmTop = errorField ? errorField.getBoundingClientRect().top + window.scrollY - 100 : 0;

                    window.scrollTo(0, elmTop);
                }

            },

            // this function looks for a class with a label that we are editing and replaces the old class with the new
            editClassificationPlanEntryRec(classificationPlan) {

                if (classificationPlan.classificationLabel === this.selectedClassLabel) {


                    // todo: tule je treba primerjat, če sta classificationPlan in

                    if (_.isEqual(classificationPlan, this.newClassificationPlanEntry)) {
                        this.newClassificationPlanEntry.structure.changed = false;
                    } else {
                        this.newClassificationPlanEntry.structure.changed = true;
                    }

                    classificationPlan = this.newClassificationPlanEntry;
                    return classificationPlan;
                }

                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.editClassificationPlanEntryRec(classificationPlan.item[i]);
                }

                return classificationPlan;

            },


            updateClassificationLabelErrors(classificationPlan) {


                if (classificationPlan.parentClass !== "none") {
                    if (classificationPlan.classificationLabel.startsWith(classificationPlan.parentClass) && classificationPlan.classificationLabel.length > classificationPlan.parentClass.length) {
                        classificationPlan.errors.classificationLabel.valueError = false;
                        for (let i = 0; i < classificationPlan.item.length; i++) {
                            this.updateClassificationLabelErrors(classificationPlan.item[i]);
                        }
                    } else {
                        classificationPlan.errors.classificationLabel.valueError = true;
                        classificationPlan = this.updateClassificationLabelErrorsChildren(classificationPlan);
                    }
                } else {
                    classificationPlan.errors.classificationLabel.valueError = false;
                }

            },

            updateClassificationLabelErrorsChildren(classificationPlan) {
                console.log("UPDATE ERRORS CHILDREN", classificationPlan.classificationLabel);
                classificationPlan.errors.classificationLabel.valueError = true;
                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.updateClassificationLabelErrorsChildrenRec(classificationPlan.item[i]);
                }

                return classificationPlan;
            },

            updateClassificationLabelErrorsChildrenRec(classificationPlan) {
                console.log("CLASSIFICATION PLAN WITH LABEL", classificationPlan.classificationLabel, classificationPlan.errors.classificationLabel.valueError);
                classificationPlan.errors.classificationLabel.valueError = true;
                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.updateClassificationLabelErrorsChildrenRec(classificationPlan.item[i]);
                }

                return classificationPlan;
            },


            // if we are in the edit mode, this function gets called, when the page is mounted, it finds the class that we are editing in the structure and clones it to the newClassificationPlanEntry
            returnClass(classificationLabel) {

                if(classificationLabel === "none"){
                    return this.classificationPlan;
                }

                for (let i = 0; i < this.classificationPlan.length; i++) {

                    let returnedClass = this.returnClassRec(classificationLabel, this.classificationPlan[i]);

                    if(returnedClass != null){
                        return returnedClass;
                    }

                }
                return null;

            },

            returnClassRec(classificationLabel, classificationPlan) {


                if (classificationPlan.classificationLabel === classificationLabel) {

                    return classificationPlan;
                }

                for (let i = 0; i < classificationPlan.item.length; i++) {
                    let returnedClass = this.returnClassRec(classificationLabel, classificationPlan.item[i]);

                    if(returnedClass != null){
                        return returnedClass;
                    }

                }

                return null;

            },



            returnSiblingArray(classificationLabel) {

                if(classificationLabel === "none"){

                    let siblingArray = _.cloneDeep(this.classificationPlan);

                    for(let i = siblingArray.length-1; i >= 0; i--) {
                        if(siblingArray[i].classificationLabel == this.newClassificationPlanEntry.classificationLabel ){
                            siblingArray.splice(i, 1);
                        }
                    }

                    return siblingArray;
                }

                for (let i = 0; i < this.classificationPlan.length; i++) {

                    let returnedArray = this.returnSiblingArrayRec(classificationLabel, this.classificationPlan[i]);

                    if(returnedArray != null){


                        return returnedArray;
                    }

                }

                return [];

            },

            returnSiblingArrayRec(classificationLabel, classificationPlan) {


                if (classificationPlan.classificationLabel === classificationLabel) {

                    let siblingArray = [];

                    if(classificationPlan.item){
                        siblingArray = _.cloneDeep(classificationPlan.item);
                    }

                    if(this.mode === "edit"){

                        for(let i = siblingArray.length-1; i >= 0; i--) {
                            if(siblingArray[i].classificationLabel == this.newClassificationPlanEntry.classificationLabel ){
                                siblingArray.splice(i, 1);
                            }
                        }
                    }

                    return siblingArray;

                }

                for (let i = 0; i < classificationPlan.item.length; i++) {

                    let returnedArray = this. returnSiblingArrayRec(classificationLabel, classificationPlan.item[i]);

                    if(returnedArray != null){
                        return returnedArray;
                    }

                }

                return null;

            },


            checkForClassificationLabelNameDuplicateError(){

                console.log("sibling array: ", this.siblingArray);
                console.log("classification label name: ", this.newClassificationPlanEntry.classificationLabel);


                for(let i=0; i<this.siblingArray.length; i++){

                    if(/*this.siblingArray[i].classificationLabelName && this.siblingArray[i].classificationLabelName.toLowerCase() == this.newClassificationPlanEntry.classificationLabelName.toLowerCase()*/false ){

                        this.newClassificationPlanEntry.errors.classificationLabelNameDuplicateError = true;
                        return true;
                    }

                }

                this.newClassificationPlanEntry.errors.classificationLabelNameDuplicateError = false;
                return false;

            },

            checkForClassificationLabelNameIllegalCharactersError() {

                let regex = RegExp("^[a-zA-Z0-9ČĆŠĐŽčćšđž_./():,\\- ]+$");

                if (regex.test(this.newClassificationPlanEntry.classificationLabelName)) {
                    this.newClassificationPlanEntry.errors.classificationLabelNameIllegalCharactersError = false;
                    return false;
                } else {
                    this.newClassificationPlanEntry.errors.classificationLabelNameIllegalCharactersError = true;
                    return true;
                }
            },

            checkSiblingClassesForClassificationLabelNameDuplicateError(){



                let valid = true;

                let parentObject = this.returnClass(this.newClassificationPlanEntry.parentClass);

                let siblingsArray = [];

                if(parentObject.length == null){

                    if(parentObject.item){
                        siblingsArray = parentObject.item;
                    }
                }
                else {
                    siblingsArray = parentObject;
                }


                if(siblingsArray.length > 0){

                    let childClassificationLabelNames = {};

                    for(let i=0; i<siblingsArray.length; i++){

                        if(!childClassificationLabelNames[siblingsArray[i].classificationLabelName]){

                            childClassificationLabelNames[siblingsArray[i].classificationLabelName] = [];
                            childClassificationLabelNames[siblingsArray[i].classificationLabelName].push(i);

                        }
                        else{
                            childClassificationLabelNames[siblingsArray[i].classificationLabelName].push(i);
                        }

                    }



                    for (let key of Object.keys(childClassificationLabelNames)){

                        if(childClassificationLabelNames[key].length > 1){

                            for(let i = 0; i < childClassificationLabelNames[key].length; i++ ){
                                //siblingsArray[childClassificationLabelNames[key][i]].errors.classificationLabelNameDuplicateError = true;
                                valid = false;
                                //console.log("nastavimo na true, ker se: ", key , " pojavi ",  childClassificationLabelNames[key].length, "-krat --->", childClassificationLabelNames[key] );
                            }

                        }
                        else {

                            //console.log("damo na false in sicer ", childClassificationLabelNames[key][0]);
                            siblingsArray[childClassificationLabelNames[key][0]].errors.classificationLabelNameDuplicateError = false;
                        }
                    }

                }


                return valid;
            },


            //\_/\_/\\ MODALS FUNCTIONS //\_/\_/\\


            //EXPIRATION MODALS FUNCTIONS


            //add expiration functions
            showAddExpirationModal() {

                this.$bvModal.show('modal-add-expiration');
            },

            closeAddExpirationModal() {

                this.$bvModal.hide('modal-add-expiration');
                this.newExpiration = {expiration: null, expirationType: null, isGeneral: false, year: null};
                this.newExpirationErrorsEntry = {
                    expiration: false,
                    year: {missing: false, numericError: false},
                    expirationType: false
                };
                this.duplicateExpirationError = false;
            },

            addExpiration() {

                // before we add an expiration entry, we need to validate the expiration entry that we want to add and check all of the entries for general expiration errors
                if (this.validateArrayField("rokHrambe")) {


                    if (this.validateForGeneralExpirationErrors(true) && this.checkForDuplicatesInArrayField("rokHrambe", "add")) {

                        // if both validations go through, we can add a new expiration entry
                        // ( we can't add a new class if it causes a general expiration error -- we can edit and delete them that way, that is why we pass true to the validation function - so the validation function knows that we are adding a new entry and returns false and doesn't update the error fields if we encounter a general expiration error )
                        this.newClassificationPlanEntry.rokHrambe.push(this.newExpiration);
                        this.newClassificationPlanEntry.errors.rokHrambe.expirationFields.push(this.newExpirationErrorsEntry);

                        this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
                        this.newExpirationErrorsEntry = {
                            expiration: false,
                            year: {missing: false, numericError: false},
                            expirationType: false
                        };
                        this.duplicateExpirationError = false;
                        this.$bvModal.hide('modal-add-expiration');
                    } else if (!this.validateForGeneralExpirationErrors(true)) {
                        this.$bvModal.show('modal-generalExpiration-error');
                    }
                }
            },

            //edit expiration functions
            showEditExpirationModal($event, row) {

                this.selectedRow = row;
                this.newExpiration = _.cloneDeep(this.newClassificationPlanEntry.rokHrambe[row.index]);
                this.newExpirationErrorsEntry = _.cloneDeep(this.newClassificationPlanEntry.errors.rokHrambe.expirationFields[row.index]);

                this.$bvModal.show('modal-edit-expiration');
            },

            closeEditExpirationModal() {

                this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
                this.newExpirationErrorsEntry = {
                    expiration: false,
                    year: {missing: false, numericError: false},
                    expirationType: false
                };
                this.duplicateExpirationError = false;
                this.$bvModal.hide('modal-edit-expiration');
            },

            editExpiration() {

                // before we save the edited expiration entry, we need to validate the expiration entry that we have edited
                if (this.validateArrayField("rokHrambe") && this.checkForDuplicatesInArrayField("rokHrambe", "edit")) {


                    this.newClassificationPlanEntry.rokHrambe[this.selectedRow.index] = this.newExpiration;
                    this.newClassificationPlanEntry.errors.rokHrambe.expirationFields[this.selectedRow.index] = this.newExpirationErrorsEntry;

                    this.newExpiration = {expiration: null, expirationType: null, year: null, isGeneral: false};
                    this.newExpirationErrorsEntry = {
                        expiration: false,
                        year: {missing: false, numericError: false},
                        expirationType: false
                    };
                    this.duplicateExpirationError = false;
                    // here we pass false to the validateForGeneralExpirationErrors() function -- that way the function just updates the fields for general expiration errors, because we just want to show the error when editing or deleting expiration entries
                    this.validateForGeneralExpirationErrors(false);

                    this.$bvModal.hide('modal-edit-expiration');

                }

            },

            //delete expiration functions

            showDeleteExpirationModal($event, row) {

                this.selectedRow = row;
                this.$bvModal.show('modal-delete-expiration');
            },

            closeDeleteExpirationModal() {

                this.$bvModal.hide('modal-delete-expiration');
            },

            deleteExpiration() {

                this.newClassificationPlanEntry.rokHrambe.splice(this.selectedRow.index, 1);
                this.newClassificationPlanEntry.errors.rokHrambe.expirationFields.splice(this.selectedRow.index, 1);

                this.validateForGeneralExpirationErrors(false);

                this.$bvModal.hide('modal-delete-expiration');
            },


            //CONNECTED SYSTEMS MODALS FUNCTIONS


            //add connected systems functions

            showAddConnectedSystemsModal() {

                this.$bvModal.show('modal-add-connectedSystem');
            },

            closeAddConnectedSystemsModal() {

                this.$bvModal.hide('modal-add-connectedSystem');
                this.newConnectedSystem = null;
                this.newConnectedSystemErrors = false;
                this.duplicateConnectedSystemsError = false;
            },

            addConnectedSystems() {

                if (this.validateArrayField("povezaniSistemi") && this.checkForDuplicatesInArrayField("povezaniSistemi", "add")) {

                    this.newClassificationPlanEntry.povezaniSistemi.push(this.newConnectedSystem);
                    this.newClassificationPlanEntry.errors.povezaniSistemi = (this.newClassificationPlanEntry.povezaniSistemi.length === 0);

                    this.newConnectedSystem = null;
                    this.newConnectedSystemErrors = false;
                    this.duplicateConnectedSystemsError = false;

                    this.$bvModal.hide('modal-add-connectedSystem');

                    this.getVpisnikiOptions();
                    this.newClassificationPlanEntry.errors.vpisnik = (this.newClassificationPlanEntry.vpisnik.length === 0 && !(this.filteredVpisniki.length === 0));
                }


            },


            // edit connected systems functions

            showEditConnectedSystemsModal($event, row) {
                let _this = this;

                console.log("ROW", row);

                this.selectedRow = row;

                if(_.filter(this.povezaniSistemi, {'id': row.item})[0]) {
                  this.newConnectedSystem = _.filter(this.povezaniSistemi, {'id': row.item})[0].id;
                } else {
                  this.newConnectedSystem = row.item;
                }


                let shouldNotEdit = false;

                _.forEach(_this.newClassificationPlanEntry.vpisnik, function (value,key) {

                    let vpisnikItem = _.filter(_this.vpisniki, {'id': value.toString()})[0];

                    if (vpisnikItem) {

                        if(vpisnikItem.connectedSystem.toString() === _this.selectedRow.item.toString()) {
                            shouldNotEdit = true;
                        }
                    }
                });

                if(shouldNotEdit) {
                    _this.$swal("", this.$t('text.classificationPlanEntry.connectedSystemShouldNotEditSwal.content1') + _this.getConnectedSystemReadableLabel(_this.selectedRow.item) +  this.$t('text.classificationPlanEntry.connectedSystemShouldNotEditSwal.content2') , "info", {dangerMode: false});
                    return;
                } else {
                    this.$bvModal.show('modal-edit-connectedSystem');
                }


            },

            closeEditConnectedSystemsModal() {

                this.$bvModal.hide('modal-edit-connectedSystem');
                this.newConnectedSystem = null;
                this.newConnectedSystemErrors = false;
                this.duplicateConnectedSystemsError = false;
            },

            editConnectedSystems() {

                if (this.validateArrayField("povezaniSistemi") && this.checkForDuplicatesInArrayField("povezaniSistemi", "edit")) {

                    this.newClassificationPlanEntry.povezaniSistemi[this.selectedRow.index] = this.newConnectedSystem;

                    this.newConnectedSystem = null;
                    this.newConnectedSystemErrors = false;
                    this.duplicateConnectedSystemsError = false;

                    this.$bvModal.hide('modal-edit-connectedSystem');

                    this.getVpisnikiOptions();
                    this.newClassificationPlanEntry.errors.vpisnik = (this.newClassificationPlanEntry.vpisnik.length === 0 && !(this.filteredVpisniki.length === 0));
                }
            },


            //delete connected systems functions

            showDeleteConnectedSystemsModal($event, row) {
                this.selectedRow = row;

                let _this = this;
                let shouldNotDelete = false;

                _.forEach(_this.newClassificationPlanEntry.vpisnik, function (value,key) {

                    let vpisnikItem = _.filter(_this.vpisniki, {'id': value.toString()})[0];

                    if (vpisnikItem) {

                        if(vpisnikItem.connectedSystem.toString() === _this.selectedRow.item.toString()) {
                            shouldNotDelete = true;
                        }
                    }
                });

                if(shouldNotDelete) {
                    _this.$swal("", this.$t('text.classificationPlanEntry.connectedSystemShouldNotDeleteSwal.content1') + _this.getConnectedSystemReadableLabel(_this.selectedRow.item) +  this.$t('text.classificationPlanEntry.connectedSystemShouldNotDeleteSwal.content2'), "info", {dangerMode: false});
                    return;
                }


                this.$swal({
                    title: this.$t('text.globals.warningTitle'),
                    text: this.$t('text.classificationPlanEntry.deleteConnectedSystemSwal.content') + _this.getConnectedSystemReadableLabel(_this.selectedRow.item) + "?",
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: this.$t('text.globals.cancel'),
                            value: null,
                            visible: true,
                            className: "",
                            closeModal: true,
                        },
                        confirm: {
                            text: this.$t('text.globals.delete'),
                            value: true,
                            visible: true,
                            className: "",
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteConnectedSystem();

                            case null:

                                return;

                                break;

                            default:

                        }
                    });
            },

            deleteConnectedSystem() {

                this.newClassificationPlanEntry.povezaniSistemi.splice(this.selectedRow.index, 1);
                this.newClassificationPlanEntry.errors.povezaniSistemi = (this.newClassificationPlanEntry.povezaniSistemi.length === 0);
                this.getVpisnikiOptions();
                this.newClassificationPlanEntry.errors.vpisnik = (this.newClassificationPlanEntry.vpisnik.length === 0 && !(this.filteredVpisniki.length === 0));
            },


            // REGISTRY MODALS FUNCTIONS


            //add registry functions

            showAddRegistryModal() {

                if (this.newClassificationPlanEntry.povezaniSistemi.length === 0) {
                    this.$swal("", this.$t('text.classificationPlanEntry.noConnectedSystemsAddedSwal.content'), "info", {dangerMode: false})
                } else {
                    this.$bvModal.show('modal-add-registry');
                }


            },

            closeAddRegistryModal() {

                this.$bvModal.hide('modal-add-registry');
                this.newRegistry = [];
                this.newRegistryErrors = false;
                this.duplicateRegistryError = false;
                this.newRegistryDuplicatesList = [];
            },

            addRegistry() {

                const _this = this;

                if (this.validateArrayField("vpisnik") && this.checkForDuplicatesInArrayField("vpisnik", "add")) {

                    _.forEach(this.newRegistry, function (value) {

                        if(typeof value === 'object') {
                            _this.newClassificationPlanEntry.vpisnik.push(value.id);
                        } else {
                            _this.newClassificationPlanEntry.vpisnik.push(value);
                        }
                    });

                    _this.$bvModal.hide('modal-add-registry');

                    _this.newClassificationPlanEntry.errors.vpisnik = (_this.newClassificationPlanEntry.vpisnik.length === 0 && !(_this.filteredVpisniki.length === 0));

                    _this.newRegistryErrors = false;
                    _this.newRegistry = [];
                    this.duplicateRegistryError = false;
                    this.newRegistryDuplicatesList = [];

                }


            },


            //edit registry functions

            showEditRegistryModal($event, row) {
                this.selectedRow = row;

                this.newRegistry = this.newClassificationPlanEntry.vpisnik[row.index];
                this.$bvModal.show('modal-edit-registry');
            },

            closeEditRegistryModal() {

                this.$bvModal.hide('modal-edit-registry');
                this.newRegistry = [];
                this.newRegistryErrors = false;
                this.duplicateRegistryError = false;
            },

            editRegistry() {

                if (this.validateArrayField("vpisnik") && this.checkForDuplicatesInArrayField("vpisnik", "edit")) {
                    this.newClassificationPlanEntry.vpisnik[this.selectedRow.index] = this.newRegistry;

                    this.$bvModal.hide('modal-edit-registry');

                    this.newRegistry = [];
                    this.newRegistryErrors = false;
                    this.duplicateRegistryError = false;

                }

            },

            //delete registry functions

            showDeleteRegistryModal($event, row) {

                this.selectedRow = row;


                let _this = this;

                let deleteConnectedSystemsInClassWithRecordsMessage = _this.newClassificationPlanEntry.containsRecords ? '\n\n' + _this.$t('text.classificationPlanEntry.deleteConnectedSystemsInClassWithRecordsSwal.content') : '';

                this.$swal({
                    title: this.$t('text.globals.warningTitle'),
                    text: this.$t('text.classificationPlanEntry.deleteRegistrySwal.content') + _this.getRegisterItemReadableLabel(_this.selectedRow.item) + "?" + deleteConnectedSystemsInClassWithRecordsMessage,
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: this.$t('text.globals.cancel'),
                            value: null,
                            visible: true,
                            className: "",
                            closeModal: true,
                        },
                        confirm: {
                            text: this.$t('text.globals.delete'),
                            value: true,
                            visible: true,
                            className: "",
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteRegistry();

                            case null:

                                return;

                                break;

                            default:

                        }
                    });

            },


            deleteRegistry() {

                this.newClassificationPlanEntry.vpisnik.splice(this.selectedRow.index, 1);
                this.newClassificationPlanEntry.errors.vpisnik = (this.newClassificationPlanEntry.vpisnik.length === 0 && !(this.filteredVpisniki.length === 0));

            },

    //          //\_/\\ VALIDATION FUNCTIONS //\_/\\
    //         <| o o |>                    <| o o |>
    //          |  *  |                     ||  *  ||
    //           \ - /                     //|\ - /|\\
    //            |_|     /\/\/\/\/\/\/\/\     |_|


            // validate a string type field in the form
            validateField(fieldName) {

                // classification label has an error object with an attributes missing and valueError to set errors
                if (fieldName === "classificationLabel") {

                    this.newClassificationPlanEntry.errors.classificationLabel.missing = (this.newClassificationPlanEntry.classificationLabel == null || this.newClassificationPlanEntry.classificationLabel === "");

                    return !this.newClassificationPlanEntry.errors.classificationLabel.missing;

                }
                // for expiration we just check if there is one
                else if (fieldName === "expiration") {

                    this.newExpirationErrorsEntry.expiration = (this.newExpiration.expiration == null || this.newExpiration.expiration === "");
                    return !this.newExpirationErrorsEntry.expiration;

                }
                // if expiration is  set to "OMEJENO" we also need to validate the year variable, otherwise not
                else if (fieldName === "year") {

                    if (this.newExpiration.expiration === "OMEJENO") {

                        this.newExpirationErrorsEntry.year.missing = (this.newExpiration.year == null || this.newExpiration.year === "");
                        this.newExpirationErrorsEntry.year.numericError = isNaN(this.newExpiration.year) || !this.newExpiration.year.match(/^[1-9]\d*$/);
                    } else {

                        this.newExpirationErrorsEntry.year.missing = false;
                        this.newExpirationErrorsEntry.year.numericError = false;

                    }

                    return !(this.newExpirationErrorsEntry.year.missing || this.newExpirationErrorsEntry.year.numericError);

                }
                // if the expiration is general, we dont validate expirationType, otherwise we do
                else if (fieldName === "expirationType") {

                    if (this.newExpiration.isGeneral) {

                        this.newExpirationErrorsEntry.expirationType = false;
                    } else {

                        this.newExpirationErrorsEntry.expirationType = (this.newExpiration.expirationType == null || this.newExpiration.expirationType === "");

                    }

                    return !this.newExpirationErrorsEntry.expirationType;
                }
                // in general we check if the field exists and save the potential error to the error object
                else {

                    this.newClassificationPlanEntry.errors[fieldName] = (this.newClassificationPlanEntry[fieldName] == null || this.newClassificationPlanEntry[fieldName] === "");

                    return !this.newClassificationPlanEntry.errors[fieldName];
                }


            },

            // validate an array type field in the form
            validateArrayField(fieldName) {

                if (fieldName === "povezaniSistemi" || fieldName === "vpisnik") {

                    // if the field is connected systems, we set an error if we have an empty field
                    if (fieldName === "povezaniSistemi") {

                        this.newConnectedSystemErrors = (this.newConnectedSystem === "" || this.newConnectedSystem == null);

                        return !this.newConnectedSystemErrors;

                    }
                    // if the field is registry, we set an error if we have an empty field
                    else if (fieldName === "vpisnik") {

                        this.newRegistryErrors = (this.newRegistry == null || this.newRegistry.length === 0 || this.newRegistry === "");

                        return !this.newRegistryErrors;
                    }

                }
                // if the field is epiration, we check all the fields in the new expiration entry and set the errors
                else if (fieldName === "rokHrambe") {

                    let rokHrambeEntryError = true;

                    for (let key of Object.keys(this.newExpirationErrorsEntry)) {

                        if (!this.validateField(key)) {
                            rokHrambeEntryError = false;
                        }
                    }

                    return rokHrambeEntryError;
                }

            },

            // validate the expiration field for general expiration errors
            validateForGeneralExpirationErrors(addMode) {

                let generalExpirationNumber = 0;


                // we iterate through all of the existing expiration entries and also the new one that we want to add and count the number of general expirations
                for (let i = 0; i < this.newClassificationPlanEntry.rokHrambe.length; i++) {

                    if (this.newClassificationPlanEntry.rokHrambe[i].isGeneral) {

                        generalExpirationNumber++;
                    }

                }

                if (this.newExpiration.isGeneral) {

                    generalExpirationNumber++;
                }


                // if there is one general expiration, we set the generalExpirationError to false and return true (no errors)
                if (generalExpirationNumber === 1) {


                    this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = false;


                    return true;

                }
                // if there is no general expirations and we want to add an expiration that is not a general one (addMode !), we return true (no errors), so the validation goes through when adding, but we set the  generalExpirationError to true (so we display that we need to add a general expiration)
                else if (generalExpirationNumber === 0) {

                    if (addMode) {

                        this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

                        return true;

                    } else {

                        this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

                        return false;

                    }

                }
                // if we want to add a general expiration but there is already one added, we return false (error) so the validation doesn't go through when adding and we also dont' set the generalExpirationError, because the class won't be added,
                // --- if we are not in adding , we let the user to make general expiration errors, so we set the generalExpirationError to true - the functions for editig and deleting let the user through
                else {

                    if (addMode) {

                        return false;
                    } else {

                        this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;

                        return false;
                    }


                }

            },


            validateUsageEndDate() {

                let creationDate = this.moment(this.newClassificationPlanEntry.creationDate, 'DD-MM-YYYY');
                let usageEndDate = this.moment(this.newClassificationPlanEntry.usageEndDate, 'DD-MM-YYYY');

                if (this.showCollapseClose) {
                    if(this.moment(creationDate).isSame(this.moment(usageEndDate), 'day') || this.moment(usageEndDate).isAfter(this.moment(creationDate))) {
                        this.usageEndDateValueErrors = false;
                    } else {
                        this.usageEndDateValueErrors = true;

                        return false;
                    }

                    this.usageEndDateErrors = (this.newClassificationPlanEntry.usageEndDate == null || this.newClassificationPlanEntry.usageEndDate === "");
                    return !this.usageEndDateErrors;

                } else {
                    return true
                }
            },


            validateClassificationLabel() {


                let regex = RegExp("^[0-9]+$");

                if (this.newClassificationPlanEntry.parentClass !== "none") {
                    if (this.newClassificationPlanEntry.classificationLabel.startsWith(this.newClassificationPlanEntry.parentClass) && (this.newClassificationPlanEntry.classificationLabel.length > this.newClassificationPlanEntry.parentClass.length) && regex.test(this.newClassificationPlanEntry.classificationLabel) ) {
                        this.newClassificationPlanEntry.errors.classificationLabel.valueError = false;
                    } else {
                        this.newClassificationPlanEntry.errors.classificationLabel.valueError = true;
                    }
                }
                else {

                    console.log("osnovni nivo in ali je numerično: ", regex.test(this.newClassificationPlanEntry.classificationLabel) );

                    if(regex.test(this.newClassificationPlanEntry.classificationLabel)) {
                        this.newClassificationPlanEntry.errors.classificationLabel.valueError = false;
                    }
                    else {
                        this.newClassificationPlanEntry.errors.classificationLabel.valueError = true;
                    }

                }

                return !this.newClassificationPlanEntry.errors.classificationLabel.valueError;
            },


            checkForDuplicatesInArrayField(fieldType, mode) {

                if (fieldType === "povezaniSistemi") {

                    // če je mode edit preverimo, če je selected row.index enak trenutnemu in spustimo čez, če je

                    for (let i = 0; i < this.newClassificationPlanEntry.povezaniSistemi.length; i++) {
                        if (this.newClassificationPlanEntry.povezaniSistemi[i] === this.newConnectedSystem) {
                            if (mode === "edit") {
                                if (this.selectedRow.index === i) {
                                    this.duplicateConnectedSystemsError = false;
                                    return true;
                                } else {
                                    this.duplicateConnectedSystemsError = true;
                                    return false;
                                }

                            } else if (mode === "add") {

                                this.duplicateConnectedSystemsError = true;
                                return false;


                            }
                        }

                    }
                    this.duplicateConnectedSystemsError = false;
                    return true;


                } else if (fieldType === "vpisnik") {
                    if (mode === "edit") {

                        for (let i = 0; i < this.newClassificationPlanEntry.vpisnik.length; i++) {
                            if (this.newClassificationPlanEntry.vpisnik[i] === this.newRegistry) {

                                if (this.selectedRow.index === i) {
                                    this.duplicateRegistryError = false;
                                    return true;
                                } else {
                                    this.duplicateRegistryError = true;
                                    return false;
                                }


                            }
                        }
                        this.duplicateRegistryError = false;
                        return true;

                    } else if (mode === "add") {

                        this.newRegistryDuplicatesList = [];
                        this.duplicateRegistryError = false;

                        for (let i = 0; i < this.newRegistry.length; i++) {

                            if (this.newClassificationPlanEntry.vpisnik.includes(this.newRegistry[i])) {

                                this.newRegistryDuplicatesList.push(this.newRegistry[i]);
                                this.duplicateRegistryError = true;
                            }


                        }

                        if (this.duplicateRegistryError) {
                            return false;
                        } else {
                            return true;
                        }

                    }
                } else if (fieldType === "rokHrambe") {

                    for (let i = 0; i < this.newClassificationPlanEntry.rokHrambe.length; i++) {
                        if (this.newClassificationPlanEntry.rokHrambe[i].expirationType === this.newExpiration.expirationType) {
                            if (mode === "edit") {
                                if (this.selectedRow.index === i) {
                                    this.duplicateExpirationError = false;
                                    return true;
                                } else {
                                    this.duplicateExpirationError = true;
                                    return false;
                                }

                            } else if (mode === "add") {

                                this.duplicateExpirationError = true;
                                return false;


                            }
                        }
                    }
                    this.duplicateExpirationError = false;
                    return true;
                }


            },

            // validate the whole class one more time before saving it to the structure --> some fields might not yet be validated (for example if we are adding a new class and we haven't changed the input fields)
            validateClass() {

                // if an empty field is found, we write that to the errors structure --> later when displaying the classification plan we will mark the classes with invalid fields

                // we will return this variable at the end -- if there are no errors, this variable will stay unchanged
                let validationSuccessful = true;


                // we loop through all the fields in the classification plan entry class
                for (let key of Object.keys(this.newClassificationPlanEntry.errors)) {


                    if (key === "rokHrambe" || key === "povezaniSistemi" || key === "vpisnik") {

                        // validation for the key 'rokHrambe'
                        if (key === "rokHrambe") {

                            this.newClassificationPlanEntry.errors.rokHrambe.expirationErrors = false;
                            this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = false;


                            // if the rokHrambe is an empty array, we just set the expirationErrors (general errors) and generalExpirationError (there should be one general expiration) to true
                            if (this.newClassificationPlanEntry.rokHrambe.length === 0) {

                                validationSuccessful = false;
                                this.newClassificationPlanEntry.errors.rokHrambe.expirationErrors = true;
                                this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;
                            }
                            //else we check all of the expiration entries and also count how many of them are general (there needs to be only one for each class)
                            else {

                                this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = false;
                                let generalExpirationNumber = 0;

                                for (let i = 0; i < this.newClassificationPlanEntry.rokHrambe.length; i++) {

                                    //if the expiration is general, we increase the number of general expirations inside the class
                                    if (this.newClassificationPlanEntry.rokHrambe[i].isGeneral) {
                                        generalExpirationNumber++;
                                    }

                                    // for expiration we just check if there is one present
                                    let expiration = (this.newClassificationPlanEntry.rokHrambe[i].expiration == null || this.newClassificationPlanEntry.rokHrambe[i].expiration === "");
                                    let year = {
                                        missing: false,
                                        numericError: false
                                    };
                                    let expirationType = false;

                                    // if expiration is  set to "OMEJENO" we also need to validate the year variable, otherwise not
                                    if (this.newClassificationPlanEntry.rokHrambe[i].expiration === 'OMEJENO') {

                                        year.missing = (this.newClassificationPlanEntry.rokHrambe[i].year == null || this.newClassificationPlanEntry.rokHrambe[i].year === "");
                                        year.numericError = isNaN(this.newClassificationPlanEntry.rokHrambe[i].year);

                                    } else {

                                        year.missing = false;
                                        year.numericError = false;

                                    }

                                    // if the expiration is general, we dont validate expirationType, otherwise we do
                                    if (this.newClassificationPlanEntry.rokHrambe[i].isGeneral) {

                                        expirationType = false;
                                    } else {

                                        expirationType = (this.newClassificationPlanEntry.rokHrambe[i].expirationType == null || this.newClassificationPlanEntry.rokHrambe[i].expirationType === "");
                                    }


                                    // we set an errors object for this expiration entry to (potentially) new values
                                    this.newClassificationPlanEntry.errors.rokHrambe.expirationFields[i] = {

                                        expiration: expiration,
                                        expirationType: expirationType,
                                        year: year,

                                    }

                                    // if there is an error in any of the fields we set an expiration error
                                    if (expiration || year.missing || year.numericError || expirationType) {

                                        this.newClassificationPlanEntry.errors.rokHrambe.expirationErrors = true;
                                        validationSuccessful = false;
                                    }
                                }

                                // if the number of general expirations in the class is not 1, we set a general expiration error
                                if (generalExpirationNumber !== 1) {

                                    this.newClassificationPlanEntry.errors.rokHrambe.generalExpirationError = true;
                                    this.newClassificationPlanEntry.errors.rokHrambe.expirationErrors = true;
                                    validationSuccessful = false;
                                }
                            }
                        }
                        // if the field is an array ("vpisnik" or "povezaniSistemi" ) we just check its length (if it's not 0)
                        else if(key === "vpisnik"){
                            if ((this.newClassificationPlanEntry[key].length === 0) === (this.filteredVpisniki.length === 0)) {
                                this.newClassificationPlanEntry.errors[key] = false;
                            }
                            else{
                                this.newClassificationPlanEntry.errors[key] = true;
                                validationSuccessful = false;
                            }
                        }
                        else{
                            if (this.newClassificationPlanEntry[key].length === 0) {

                                validationSuccessful = false;
                                this.newClassificationPlanEntry.errors[key] = true;
                            }
                            else {

                                this.newClassificationPlanEntry.errors[key] = false;
                            }
                        }
                    }
                    else {

                        // classification label has an error object with attributes missing and valueError to mark errors in
                        if (key === "classificationLabel") {

                            if (this.newClassificationPlanEntry.classificationLabel == null || this.newClassificationPlanEntry.classificationLabel === "") {

                                this.newClassificationPlanEntry.errors.classificationLabel.missing = true;
                                validationSuccessful = false;
                            } else {

                                this.newClassificationPlanEntry.errors.classificationLabel.missing = false;

                                if (this.validateClassificationLabel()) {

                                    this.newClassificationPlanEntry.errors.classificationLabel.valueError = false;
                                } else {

                                    this.newClassificationPlanEntry.errors.classificationLabel.valueError = true;
                                    validationSuccessful = false;
                                }
                            }
                        }

                        else if (key === "classificationLabelNameDuplicateError") {


                            this.checkForClassificationLabelNameDuplicateError();

                            if(this.newClassificationPlanEntry.errors.classificationLabelNameDuplicateError) {
                                validationSuccessful = false;
                            }

                        }

                        else if (key === "classificationLabelNameIllegalCharactersError") {


                            this.checkForClassificationLabelNameIllegalCharactersError();

                            if(this.newClassificationPlanEntry.errors.classificationLabelNameIllegalCharactersError) {
                                validationSuccessful = false;
                            }

                        }

                        // in general we check if the field exists and save the potential error to the error object
                        else {

                            if (this.newClassificationPlanEntry[key] == null || this.newClassificationPlanEntry[key] === "") {

                                this.newClassificationPlanEntry.errors[key] = true;
                                validationSuccessful = false;
                            } else {

                                this.newClassificationPlanEntry.errors[key] = false;
                            }
                        }
                    }
                }

                // we return the validationSuccessful variable which indicated if any errors were detected in the class
                return validationSuccessful;
            },

            // select all items in dropdown
            selectAllVpisnik() {
                const _this = this;

                _this.newRegistry = [];

                _.forEach(_this.vpisniki, function (value) {

                    if (_this.newClassificationPlanEntry.vpisnik.indexOf(value.id.toString()) < 0 && _this.newClassificationPlanEntry.povezaniSistemi.indexOf(value.connectedSystem) > -1) {

                        _this.newRegistry.push(value);
                    }
                });
            },


            // clearing hidden fields


            clearExpirationType() {

                if (this.newExpiration.isGeneral) {

                    this.newExpiration.expirationType = null;
                    this.newExpirationErrorsEntry.expirationType = false;
                    this.duplicateExpirationError = false;
                }

            },


            clearYear() {

                if ((this.previouslySelectedExpiration === 'OMEJENO' || this.previouslySelectedExpiration == null)  && this.newExpiration.expiration !== 'OMEJENO') {
                    this.newExpiration.year = null;
                    this.newExpirationErrorsEntry.year.numericError = false;
                    this.newExpirationErrorsEntry.year.missing = false;
                }

                this.previouslySelectedExpiration = this.newExpiration.expiration;

            },

            updateNewClassificationLabel() {
                const _this = this;

                _this.newClassificationPlanEntry.classificationLabel = _this.selectedClassLabel;
            }


        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/ClassificationPlanEntry.vue